<div class="focus-dashboard">
  <div class="focus-sidebar">
    <inexp-focus-sidebar></inexp-focus-sidebar>
  </div>
  <div class="focus-content">
    <router-outlet></router-outlet>
  </div>
</div>
